var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portlet',{staticClass:"portlet-pt-20",attrs:{"icon":'fas fa-users portlet-icon',"title":_vm.$t('engagement.companyengagement'),"actions-block":true,"fullheight":true}},[_c('template',{slot:"portletBody"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }